import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import React from 'react'

import CloseButton from './CloseButton'
import { formatTime } from '../helpers'

import styles from './autoBookingPopover.css'

const BookingConfirmModal = ({
  appointmentTime,
  date,
  doctorName,
  locationName,
  onClose,
  patientFullName,
}) => {
  const doctorString = doctorName ? `with ${doctorName} ` : ''
  const locationString = locationName ? `at the ${locationName} location` : ''
  return (
    <div>
      <CloseButton onClose={onClose} />
      <div className={styles.headerRow}>
        <h1 className={styles.mainMessage}>
          Email sent to {patientFullName()}
        </h1>
      </div>
      <p>New patient consultation scheduled for</p>
      <p>{`${moment(date).format('MMMM D, YYYY')} at ${formatTime(appointmentTime)} ${doctorString} ${locationString}.`}</p>
    </div>
  )
}

BookingConfirmModal.propTypes = {
  appointmentTime: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  doctorName: PropTypes.string,
  locationName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  patientFullName: PropTypes.func.isRequired,
}

export default BookingConfirmModal



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/BookingPopover/AutoBookingPopover/BookingConfirmModal.js